import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setPrompt } from "store/actions/prompt";
import { isDynamicRouteMatch } from "utils/common";
import { ATTENTION_MESSAGE } from "utils/constants";

const FITNESS_ITEMS = [
  { label: "Programmes", path: "/fitness/programs" },
  { label: "Séances", path: "/fitness/sessions" },
  { label: "Exercices", path: "/fitness/exercices" },
];

const NUTRITION_ITEMS = [
  { label: "Programmes", path: "/nutrition/programs" },
  { label: "Recettes", path: "/nutrition/recipes" },
];

const APP_BAR_MOBILE = 64;

const SectionSubNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isFitness = pathname.startsWith("/fitness");
  const isNutrition = pathname.startsWith("/nutrition");

  if (!isFitness && !isNutrition) return null;

  const items = isFitness ? FITNESS_ITEMS : NUTRITION_ITEMS;

  const isActive = (itemPath) => pathname.startsWith(itemPath);

  const handleNav = (path) => {
    if (isDynamicRouteMatch(pathname)) {
      dispatch(
        setPrompt({
          isOpen: true,
          message: ATTENTION_MESSAGE,
          primaryBtnHandler: () => navigate(path),
          btnAlign: "right",
          primaryBtnColor: "error",
          secondaryBtnText: "Annuler",
        })
      );
    } else {
      navigate(path);
    }
  };

  return (
    <Box
      sx={{
        display: { xs: "flex", lg: "none" },
        position: "fixed",
        top: `${APP_BAR_MOBILE}px`,
        left: 0,
        right: 0,
        zIndex: 1100,
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #E0E4EA",
        padding: "8px 16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          backgroundColor: "#F0F2F5",
          borderRadius: "10px",
          padding: "3px",
          gap: "3px",
        }}
      >
        {items.map((item) => (
          <Box
            key={item.path}
            onClick={() => handleNav(item.path)}
            sx={{
              flex: 1,
              textAlign: "center",
              padding: "7px 4px",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: isActive(item.path) ? 600 : 400,
              color: isActive(item.path) ? "#111111" : "#757E97",
              backgroundColor: isActive(item.path) ? "#ffffff" : "transparent",
              boxShadow: isActive(item.path)
                ? "0px 1px 4px rgba(0,0,0,0.12)"
                : "none",
              cursor: "pointer",
              transition: "all 0.15s ease",
              userSelect: "none",
              WebkitTapHighlightColor: "transparent",
            }}
          >
            {item.label}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SectionSubNav;
